module.exports = __webpack_public_path__ + "static/catalogue4-d3538fa652e74fda12c3f233ec2cfd13.png";